import { inject } from '@angular/core';
import { type CanActivateFn, type CanMatchFn, Router } from '@angular/router';
import { RuntimeConfigService } from '../config/runtime-config';

/**
 * Lets a mock-page route match only when the runtime config has `mockApi` on. A production
 * build refuses to start with `mockApi` on (see `provideAuthApi`), so in production these
 * routes never match and the URL falls through to the 404 page. No second flag exists to drift.
 */
export const mockPagesGuard: CanMatchFn = () => {
  const mock = inject(RuntimeConfigService).config().mockApi;
  return mock || inject(Router).createUrlTree(['/not-found']);
};

/**
 * For a shell home that is a placeholder on a real deployment: while mock pages are on, the
 * visitor is sent on to `url`, where the area's sample home already exists. Angular rejects
 * `redirectTo` beside `canMatch`, so this is an entry guard on the placeholder route itself.
 */
export function mockHomeRedirect(url: string): CanActivateFn {
  return () =>
    inject(RuntimeConfigService).config().mockApi ? inject(Router).parseUrl(url) : true;
}
